import * as yup from 'yup'

export class CompanyRegisteredImporterDto {
  registeredImporterNumber?: string = undefined
  registeredImporterNhtsaRegistrationNumber?: string = undefined
  registeredImporterIrsNumber?: string = undefined
  needsAddress?: boolean
  needsEmail?: boolean
  needsPhone?: boolean
}

export const companyRegisteredImporterValidationSchema = yup.object<CompanyRegisteredImporterDto>({
  registeredImporterNumber: yup
    .string()
    .max(200, 'Importer # cannot be more than 200 characters.')
    .required('Importer # is required.'),
  registeredImporterNhtsaRegistrationNumber: yup
    .string()
    .max(200, 'NHTSA Registration # cannot be more than 200 characters.')
    .required('NHTSA Registration # is required.'),
  registeredImporterIrsNumber: yup
    .string()
    .max(200, 'Registered Importer IRS # cannot be more than 200 characters.')
    .required('Registered Importer IRS # is required.')
})
